import angular from 'angular';
import _ from 'lodash-es';
import Utils from '~/scripts/services/utils';

export default class Evaluator {
	#cache;

	#noeval;

	#templateSettings;

	/* @ngInject */
	constructor() {
		// noinspection RegExpRedundantEscape
		this.#noeval = false;
		this.#cache = {};
		this.#templateSettings = {
			evaluate:    /{%([\S\s]+?)%}/g,
			interpolate: /{{([\S\s]+?)}}/g,
			escape:      /{{{([\S\s]+?)}}}/g,
		};
	}

	// eslint-disable-next-line class-methods-use-this
	evaluate(func, arguments_) {
		return (Array.isArray(arguments_) ? func(...arguments_) : func(arguments_));
	}

	evaluator(func, ...parameters) {
		if (this.#noeval) {
			console.warn('No evaluations allowed for this renderer.');
			return _.noop;
		}

		if (typeof parameters[0] === 'object') {
			// eslint-disable-next-line no-param-reassign
			parameters = _.keys(parameters[0]);
		}
		// eslint-disable-next-line no-new-func
		return new Function(...parameters, func); // jshint ignore:line
	}

	interpolate(rawTemplate, data) {
		if (typeof rawTemplate === 'function') {
			try {
				return rawTemplate(data);
			}
			catch (error) {
				console.warn('Error interpolating template', error, data);
				return error.message;
			}
		}

		// eslint-disable-next-line no-param-reassign
		rawTemplate = String(rawTemplate);

		const hash = Utils.stringHash(rawTemplate);
		let tpl;
		if (this.#cache[hash]) {
			tpl = this.#cache[hash];
		}
		else if (this.#noeval) {
			// No cached template methods available. Use poor-mans interpolate without eval.
			return rawTemplate.replace(/({{\s*(.*)\s*}})/, (match, $1, $2) => _.get(data, $2));
		}
		else {
			tpl = this.template(rawTemplate, hash);
		}
		if (typeof tpl === 'function') {
			try {
				return tpl(data);
			}
			catch (error) {
				console.warn('Error interpolating template', error, rawTemplate, data);
				return error.message;
			}
		}
		return tpl;
	}

	template(tpl, hash) {
		let returnValue;
		// eslint-disable-next-line no-param-reassign
		hash = hash || Utils.stringHash(tpl);
		try {
			// Ensure we handle copied templates from the ejs files.
			// eslint-disable-next-line no-param-reassign
			tpl = tpl.replace(/ctx\./g, '');
			this.#cache[hash] = _.template(tpl, this.#templateSettings);
			returnValue = this.#cache[hash];
		}
		catch (error) {
			console.warn('Error while processing template', error, tpl);
		}
		return returnValue;
	}
}

const evaluatorFactory = /* @ngInject */ () => new Evaluator();

/**
 * @ngdoc service
 * @name app.Evaluator
 * @description
 * # Evaluator
 * Service in the app.
 */
angular.module('app')
	.factory('Evaluator', evaluatorFactory);
